export const getTrainingLabel = (training) => {
  switch (training) {
    case 'potty':
      return 'Potty'
    case 'basicObedience':
      return 'Basic Obedience'
    case 'advancedObedience':
      return 'Advanced Obedience'
    case 'service':
      return 'Service'
    case 'therapy':
      return 'Therapy'
    default:
      return ''
  }
}

export const phoneNumberRegex =
  /\(\d{3}\)\s?\d{3}-\d{4}|\d{3}\s?\d{3}-\d{4}|\+1\s?\d{3}-\d{3}-\d{4}|\d{10}/g
export const phoneRegex1 = /\(\d{3}\)\s?\d{7}|\d{3}[-\s]?\d{3}[-\s]?\d{4}/ // Cases: (123)456-7890, (123) 4567890, (123)4567890, 123-456-7890, +1 123-456-7890, +1 (123)456-7890, 123 456 7890 , 123 456-7890
export const phoneRegex2 = /\(\d{3}\)\s?\d{3}\s?\d{4}/ // Cases: (617) 774 8555 (617)774 8555

export const formatPeriod = (duration, period) => {
  let formattedPeriod = period.toLowerCase()
  if (formattedPeriod === 'years' && duration === 1) {
    formattedPeriod = 'year'
  } else if (formattedPeriod === 'months' && duration === 1) {
    formattedPeriod = 'month'
  } else if (formattedPeriod === 'days' && duration === 1) {
    formattedPeriod = 'day'
  }
  return formattedPeriod.charAt(0).toUpperCase() + formattedPeriod.slice(1)
}
